import React from 'react';
import core from '@gin-betting/core';

import moduleLocator from 'moduleLocator';
import MatchStub from './components/MatchStub';
import { Modules } from '../../types';

const {
    hocs: { withAsyncLoad },
    utils: { measureTime },
} = core;

export const loadMatchModule = (): Promise<Modules['match']> =>
    import(/* webpackChunkName: "match-module" */ './index').then(
        matchModule => {
            measureTime('matchModuleLoaded');
            moduleLocator.set('match', matchModule);

            return matchModule;
        }
    );

export const AsyncMatch = withAsyncLoad({
    loader: loadMatchModule,
    loading: function AsyncMatchLoading(props, { error, timedOut, isLoading }) {
        if (error) {
            console.error(error);
        }

        return (
            <MatchStub
                error={error}
                isTimeout={timedOut}
                isLoading={isLoading}
                {...props}
            />
        );
    },
    componentToRender: 'MatchDataFetcher',
});

export const AsyncSidebarMarketList = withAsyncLoad({
    loader: loadMatchModule,
    loading: () => null,
    componentToRender: 'SidebarMarketList',
});
